import { render } from "./CancelP2PArbitrage.vue?vue&type=template&id=474cd492&scoped=true"
import script from "./CancelP2PArbitrage.vue?vue&type=script&lang=js"
export * from "./CancelP2PArbitrage.vue?vue&type=script&lang=js"

import "./CancelP2PArbitrage.vue?vue&type=style&index=0&id=474cd492&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474cd492"]])

export default __exports__